import React, { useContext, useEffect, useState } from "react";
import { getHistoricalClasses } from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";
import AllAttendanceClassTable from "./AllAttendanceClassTable";
import HistoricalAllAttendanceClassTable from "./HistoricalAllAttendanceClassTable";

export default function HistoricalAllAttendanceDivisionClass({
  search,
  searchValue,
  data,
  getTeacherName,
  getLevelName,
}) {
  const [classes, setClasses] = useState([]);
  // const [lessons, setLessons] = useState([]);
  const { setLoading } = useContext(AuthContext);
  const fetchClasses = async () => {
    if (!data.id) {
      return;
    }
    try {
      setLoading(true);
      const res = await getHistoricalClasses(data.id);
      // const lessonRes = await getLessons(data.id);
      // if (!lessonRes.error) {
      // console.log({ classRes: res });
      // setLessons(lessonRes.data);
      // }
      if (!res.error) {
        // console.log({ classRes: res });
        // console.log(res.data);
        setClasses(res.data);
      }
      setLoading(false);
      // console.log(res);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  useEffect(() => {
    fetchClasses();
  }, [data]);

  return classes
    ?.filter((e) => {
      if (search?.teacher) {
        return e.teacher === search.teacher;
        // return e.teacher === search.teacher.id;
      } else {
        return true;
      }
    })
    ?.sort((a, b) => {
      return a.classCode > b.classCode ? 1 : -1;
    })
    .map((item) => {
      return (
        <HistoricalAllAttendanceClassTable
          searchValue={searchValue}
          // lessons={lessons}
          getTeacherName={getTeacherName}
          getLevelName={getLevelName}
          classData={item}
          divData={data.name}
        />
      );
    });
}
